import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  hasNextRankById,
  nextRankProgressById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import RankProgress from './RankProgress';

export default connect(
  createStructuredSelector({
    percent: withProps({coachId: userId})(nextRankProgressById),
    hasNextRank: withProps({coachId: userId})(hasNextRankById),
  }),
)(RankProgress);
